export default __webpack_public_path__ + "static/media/sketching3.1f10a866.jpg";